import React from 'react';
import alipay from '../../images/payment-methods/alipay.svg';
import wechat from '../../images/payment-methods/wechat.svg';
import visa from '../../images/payment-methods/visa.svg';

const METHODS = [
  {id: 'alipay', label: '支付寶', image: alipay},
  {id: 'wechat', label: '微信支付', image: wechat},
  {id: 'visa', label: 'Visa', image: visa}
];

// Pass the methods eligible for this particular package from the payment
// availability resolver. Unknown/loading availability deliberately shows none.
export default function PaymentMethodIcons({availableMethods = []}) {
  const rails = Array.isArray(availableMethods) ? availableMethods : [];
  const families = rails.map(method => method === 'aplus_wechat' ? 'wechat' : method);
  const visible = METHODS.filter(method => families.includes(method.id)).map(method => method.id === 'wechat' && rails.includes('aplus_wechat')
    ? {...method,label:rails.includes('wechat')?'微信支付':'微信支付'} : method);
  if (!visible.length) return null;
  return <span className="op-payment-icons" role="img"
    style={{display:'inline-flex',alignItems:'center',gap:7,height:18,verticalAlign:'middle',pointerEvents:'none'}}
    aria-label={'支援付款方式：' + visible.map(method => method.label).join('、')}>
    {visible.map(method => <img key={method.id} src={method.image} alt=""
      aria-hidden="true" width={method.id === 'visa' ? 28 : 18} height="18"
      style={{display:'block',flex:'none',width:method.id==='visa'?28:18,height:18,objectFit:'contain'}}
      className={'op-payment-icon op-payment-icon-' + method.id}/>) }
  </span>;
}
